import CartItem from '../CartItem'
import CartContext from '../../context/CartContext'

import './index.css'

const CartListView = () => (
  <CartContext.Consumer>
    {value => {
      const {cartList, removeAllCartItems} = value
      const removeall = () => {
        removeAllCartItems()
      }

      const a = cartList.map(each => each.price * each.quantity)
      const sum = a.reduce((acc, curr) => acc + curr, 0)
      return (
        <div className="cart-items-container">
          <button type="button" onClick={removeall} className="remove-all-btn">
            Remove All
          </button>
          <ul className="cart-list">
            {cartList.map(eachCartItem => (
              <CartItem key={eachCartItem.id} cartItemDetails={eachCartItem} />
            ))}
          </ul>
          <div className="checkout-container">
            <div>
              <h1>
                Order Total: <span>Rs {sum}/- </span>
              </h1>
              <p>{cartList.length} Items in cart</p>
              <button type="button" className="shop-now-btn">
                Checkout
              </button>
            </div>
          </div>
        </div>
      )
    }}
  </CartContext.Consumer>
)

export default CartListView
